import UploadProgressBar from 'app/components/UploadProgressBar';

const QrCodeTemplateUploadProgressBar = props => {
  const {
    job
  } = props;

  // this fileId matches the one in useQrCodeTemplateUploadForm
  let fileId = job.id + '-qrcodetemplate';

  return <UploadProgressBar {...{ fileId }} />;
}

export default QrCodeTemplateUploadProgressBar;

